import { AppResponse } from "src/models/app-response";
import { PaymentUser } from "src/models/payment-user";
import { endpoints } from "src/utils/api-endpoints";
import axios from 'src/utils/axios';

export async function createPaymentUser(user: PaymentUser): Promise<AppResponse<PaymentUser | null>> {
  const url = `${endpoints.paymentUser.createPaymentUser}`;
  try {
    const response = await axios.post(url, user);
    return response.data;
  } catch (error) {
    console.error('Failed to add payment user:', error);
    return { success: false, data: null, error };
  }
}

export async function getPaymentUserByOrg(orgId: string): Promise<AppResponse<PaymentUser | null>> {
  const URL = `${endpoints.paymentUser.getPaymentUser(orgId)}`;
  try {
    const response = await axios.get(URL);
    return response.data;
  } catch (error) {
    console.error('Failed to get Payment User:', error);
    return { success: false, data: null, error };
  }
}
